import moment from "moment-jalaali";
import { useContext, useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Notfound from "../Components/Common/Notfound";
import QuoteImage from "../Components/Common/QuoteImage";
import MainLayout from "../Container/Layout/MainLayout";
import { Context } from "../Context/Context";
import {
  SERVER_URL,
  answeredTicket,
  getTicketMessages,
} from "../Services/ContectService";
import { fileDownloader } from "../Utils/fileDownloader";

const DetailsTicket = () => {
  const { json, user, setLoading, loading } = useContext(Context);
  // const content = json?.DetailsTicket;

  const { id } = useParams();

  const [ticket, setTicket] = useState(null);

  const [context, setContext] = useState("");

  const [file, setFile] = useState(null);

  const [isSending, setIsSending] = useState(false);

  const messagesContainerRef = useRef(null);
  const fileInputRef = useRef(null);

  const getTicketDataHandler = async () => {
    setLoading(true);
    try {
      const { status, data } = await getTicketMessages(user, id);
      if (status === 200) {
        setTicket(data);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setLoading(false);
    }
  };

  const sendContextHandler = async () => {
    setIsSending(true);
    if (context.trim().length === 0) {
      toast.error("متن نمی‌تواند خالی باشد");
      return setIsSending(false);
    }
    const formData = new FormData();
    formData.append("context", context);
    formData.append("sender", "c");
    // if (file && !(file.type === "image/bmp" || file.type === "image/jpeg" || file.type === "image/x-png" || file.type === "image/png" || file.type === "text/plain")) {
    //     toast.error("فقط می‌توانید فایل متنی یا تصویر آپلود کنید");
    //     return setIsSending(false);
    // }
    if (file && file.size > 5 * 1024 * 1024) {
      toast.error("حداکثر حجم فایل 5 مگابایت می‌باشد");
      return setIsSending(false);
    }
    file && formData.append("file", file);
    try {
      const response = await answeredTicket(formData, user, ticket.code);
      if (response.status === 200) {
        setTicket((prevValue) => ({
          ...prevValue,
          messages: [...prevValue.messages, response.data],
        }));
        setContext("");
        setFile(null);
      }
    } catch (error) {
      toast.error(json.toast.err_1);
    } finally {
      setIsSending(false);
    }
  };

  useEffect(() => {
    getTicketDataHandler();
  }, []);

  useEffect(() => {
    if (messagesContainerRef && messagesContainerRef.current && ticket) {
      messagesContainerRef.current.scrollTop =
        messagesContainerRef.current.scrollHeight;
    }
  }, [messagesContainerRef, ticket]);

  return (
    <MainLayout>
      {loading ? (
        <div className="d-flex justify-content-center px-2 py-5 h3">
          لطفاً صبر کنید...
        </div>
      ) : ticket ? (
        <div
          className="messages-parent flex flex-col
                bg-[#D9D9D94A] border-1 border-black rounded-lg"
        >
          <div className="w-full h-[130px] flex items-center justify-between px-2 border-b-2 border-black">
            <div className="flex items-center space-x-4">
              <div>
                <QuoteImage
                  code={ticket?.service_or_order_code}
                  className="w-[150px] h-[110px] object-cover 
                                    rounded-lg border-2 border-black"
                />
              </div>
              <div className="flex flex-col gap-1">
                <div className="text-lg flex items-center">
                  <span className="text-gray-700 mr-4">
                    {/* {ticket.for_service
                      ? `مظنه ${ticket.service_or_order_code}`
                      : `سفارش ${ticket.service_or_order_code}`
                      ? `عمومی`
                      : ``
                    } */}
                    {ticket.type === "s" && `مظنه ${ticket.service_or_order_code}`}
                    {ticket.type === "o" && `سفارش ${ticket.service_or_order_code}`}
                    {ticket.type === "p" && `عمومی`}
                  </span>
                </div>
                {ticket.for_service ? (
                  <Link
                    to={`/DetailOrder/${ticket.service_or_order_code}`}
                    className="text-sm text-gray-600 mr-4"
                  >
                    مشاهده جزییات
                  </Link>
                ) : (
                  <Link
                  to={`/Order`}
                  className="text-sm text-gray-600 mr-4"
                  >
                    مشاهده جزییات
                  </Link>
                )}
              </div>
            </div>
          </div>
          <div>
            <div
              id="messages"
              className={`${
                ticket.status === "c"
                  ? "messages-container-closed"
                  : "messages-container"
              } 
                            flex flex-col space-y-4 p-3 scroll-smooth
                            scrollbar-thumb-blue scrollbar-thumb-rounded 
                            scrollbar-track-blue-lighter scrollbar-w-2 scrolling-touch`}
              ref={messagesContainerRef}
            >
              {ticket.messages.map((message) =>
                message.sender === "c" ? (
                  <div
                    className="flex items-end mb-4"
                    key={`message_${message.code || Math.random()}`}
                  >
                    <div
                      className="flex flex-col space-y-2 
                                        text-sm max-w-xs mx-2 order-2 items-start
                                        bg-gray-300 text-gray-600 rounded-lg rounded-br-none py-2"
                    >
                      <div className="px-2">{message.context}</div>
                      {message.file && message.code && (
                        <div className="px-2 py-1.5">
                          <button
                            type="button"
                            className="px-2 py-1 bg-blue-600 text-white rounded-lg"
                            onClick={() =>
                              fileDownloader(
                                `${SERVER_URL}/ticket/message/${message.code}/file/`,
                                user
                              )
                            }
                          >
                            دانلود
                          </button>
                        </div>
                      )}
                      <div className="w-full h-[1px] bg-gray-400"></div>
                      <div
                        className="flex flex-nowrap items-center justify-between 
                                        gap-3 px-2 text-xs w-full"
                      >
                        <span>
                          {moment(message.sending_date).format("jYYYY/jMM/jDD")}
                        </span>
                        <span>
                          {moment(message.sending_date).format("HH:mm")}
                        </span>
                      </div>
                    </div>
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNRJ-Itxhm2IcNzZmymTxj5IJu9R04ML9hIHvyMqzRxjt6NBzS4FGwvt_Ucq-T8Wy7t0o&usqp=CAU"
                      alt="user icon"
                      className="w-6 h-6 rounded-full order-1"
                    />
                  </div>
                ) : (
                  <div className="flex items-end justify-end mb-4">
                    <div
                      className="flex flex-col space-y-2 
                                        text-sm max-w-xs mx-2 order-1 items-end
                                        bg-blue-600 text-white rounded-lg rounded-bl-none py-2"
                    >
                      <div className="px-2">{message.context}</div>
                      {message.file && message.code && (
                        <div className="px-2 py-1.5">
                          <button
                            type="button"
                            className="px-2 py-1 bg-white text-blue-600 rounded-lg"
                            onClick={() =>
                              fileDownloader(
                                `${SERVER_URL}/ticket/message/${message.code}/file/`,
                                user
                              )
                            }
                          >
                            دانلود
                          </button>
                        </div>
                      )}
                      <div className="w-full h-[1px] bg-white"></div>
                      <div
                        className="flex flex-nowrap items-center justify-between 
                                        gap-3 px-2 text-xs w-full"
                      >
                        <span>
                          {moment(message.sending_date).format("jYYYY/jMM/jDD")}
                        </span>
                        <span>
                          {moment(message.sending_date).format("HH:mm")}
                        </span>
                      </div>
                    </div>
                    <img
                      src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQNRJ-Itxhm2IcNzZmymTxj5IJu9R04ML9hIHvyMqzRxjt6NBzS4FGwvt_Ucq-T8Wy7t0o&usqp=CAU"
                      alt="user icon"
                      className="w-6 h-6 rounded-full order-2"
                    />
                  </div>
                )
              )}
            </div>
            <div
              className={`w-full flex flex-col justify-center px-8 gap-2.5 h-[107px]
                        ${ticket.status === "c" ? "hidden" : ""}`}
            >
              <div className="w-full flex items-center gap-2">
                <div
                  className={isSending ? "pointer-events-none" : ""}
                  onClick={sendContextHandler}
                >
                  <svg
                    className="cursor-pointer"
                    width="20"
                    height="24"
                    viewBox="0 0 40 44"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M37.7261 19.2657L4.91356 0.537226C4.36046 0.226963 3.72605 0.0923221 3.09461 0.15119C2.46317 0.210059 1.86458 0.45965 1.37837 0.866807C0.892154 1.27396 0.541323 1.81942 0.372481 2.43071C0.203639 3.042 0.224778 3.69019 0.43309 4.28918L6.48778 21.9591C6.487 21.9656 6.487 21.9721 6.48778 21.9786C6.48668 21.9851 6.48668 21.9917 6.48778 21.9982L0.43309 39.7071C0.266265 40.1783 0.214902 40.6827 0.283313 41.1778C0.351723 41.673 0.53791 42.1445 0.826247 42.5528C1.11458 42.9611 1.49666 43.2942 1.9404 43.5243C2.38414 43.7544 2.8766 43.8747 3.37645 43.8751C3.91877 43.8737 4.45156 43.7325 4.92332 43.465L37.7182 24.7052C38.202 24.4342 38.6049 24.0394 38.8857 23.5613C39.1665 23.0831 39.315 22.5389 39.316 21.9844C39.317 21.4299 39.1704 20.8852 38.8914 20.406C38.6123 19.9269 38.2108 19.5306 37.728 19.2579L37.7261 19.2657ZM3.37645 40.7501V40.7325L9.26317 23.5626H20.5639C20.9783 23.5626 21.3758 23.398 21.6688 23.105C21.9618 22.8119 22.1264 22.4145 22.1264 22.0001C22.1264 21.5857 21.9618 21.1883 21.6688 20.8953C21.3758 20.6022 20.9783 20.4376 20.5639 20.4376H9.27879L3.38817 3.27355L3.37645 3.25012L36.1889 21.9669L3.37645 40.7501Z"
                      fill="black"
                    />
                  </svg>
                </div>
                <textarea
                  value={context}
                  onChange={(ev) => setContext(ev.target.value)}
                  placeholder="متن خود را وارد کنید..."
                  className="border border-black w-full rounded-lg p-2 mr-2"
                ></textarea>
                <input
                  type="file"
                  className="hidden"
                  ref={fileInputRef}
                  onChange={(ev) => setFile(ev.target.files[0])}
                />
                <div onClick={() => fileInputRef.current.click()}>
                  <svg
                    className="cursor-pointer"
                    width="27"
                    height="22"
                    viewBox="0 0 37 42"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M34.9485 19.8946C35.0938 20.0398 35.209 20.2121 35.2877 20.4018C35.3663 20.5915 35.4068 20.7948 35.4068 21.0001C35.4068 21.2055 35.3663 21.4088 35.2877 21.5985C35.209 21.7881 35.0938 21.9605 34.9485 22.1056L18.9231 38.1212C16.8716 40.1725 14.0892 41.3248 11.1881 41.3246C8.28692 41.3244 5.50468 40.1718 3.4534 38.1202C1.40211 36.0687 0.249817 33.2863 0.25 30.3852C0.250183 27.484 1.40283 24.7018 3.45437 22.6505L22.8411 2.97863C24.3057 1.51243 26.2928 0.688112 28.3653 0.687013C30.4377 0.685914 32.4257 1.50813 33.8919 2.97277C35.3581 4.43742 36.1824 6.42453 36.1835 8.49695C36.1846 10.5694 35.3624 12.5574 33.8977 14.0236L14.5071 33.6954C13.6265 34.576 12.4322 35.0708 11.1868 35.0708C9.94144 35.0708 8.74708 34.576 7.86648 33.6954C6.98588 32.8148 6.49116 31.6205 6.49116 30.3751C6.49116 29.1298 6.98588 27.9354 7.86648 27.0548L24.136 10.5275C24.2785 10.3754 24.45 10.2534 24.6404 10.1687C24.8308 10.0839 25.0362 10.0381 25.2445 10.0339C25.4529 10.0297 25.66 10.0672 25.8536 10.1442C26.0472 10.2213 26.2235 10.3363 26.372 10.4825C26.5205 10.6286 26.6383 10.803 26.7184 10.9954C26.7985 11.1878 26.8393 11.3943 26.8385 11.6026C26.8376 11.811 26.795 12.0171 26.7133 12.2088C26.6316 12.4005 26.5123 12.5739 26.3626 12.7189L10.0911 29.2638C9.94541 29.4083 9.82962 29.5801 9.75033 29.7694C9.67104 29.9587 9.62982 30.1617 9.629 30.367C9.62818 30.5722 9.6678 30.7755 9.74557 30.9654C9.82335 31.1553 9.93777 31.3281 10.0823 31.4738C10.2268 31.6194 10.3986 31.7352 10.5879 31.8145C10.7772 31.8938 10.9802 31.935 11.1855 31.9358C11.3907 31.9367 11.594 31.897 11.7839 31.8193C11.9739 31.7415 12.1466 31.6271 12.2923 31.4825L31.6809 11.8204C32.5615 10.9416 33.057 9.74903 33.0583 8.50495C33.0595 7.26088 32.5666 6.06724 31.6878 5.18664C30.809 4.30604 29.6164 3.8106 28.3723 3.80932C27.1282 3.80804 25.9346 4.30102 25.054 5.17981L5.67117 24.8439C4.94505 25.5688 4.36884 26.4297 3.97542 27.3774C3.58201 28.325 3.3791 29.3409 3.37829 30.367C3.37747 31.393 3.57876 32.4092 3.97067 33.3575C4.36257 34.3058 4.93742 35.1676 5.66238 35.8937C6.38734 36.6198 7.24823 37.196 8.19588 37.5894C9.14353 37.9828 10.1594 38.1857 11.1855 38.1866C12.2115 38.1874 13.2277 37.9861 14.176 37.5942C15.1243 37.2023 15.9861 36.6274 16.7122 35.9025L32.7395 19.8868C33.0336 19.5951 33.4314 19.432 33.8456 19.4335C34.2599 19.4349 34.6566 19.6008 34.9485 19.8946Z"
                      fill="black"
                    />
                  </svg>
                </div>
              </div>
              {file && (
                <div className="flex gap-1 px-8">
                  <div onClick={() => setFile(null)}>
                    <svg
                      className="cursor-pointer"
                      width="22px"
                      height="22px"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M11 19H5C3.89543 19 3 18.1046 3 17V7C3 5.89543 3.89543 5 5 5H9.58579C9.851 5 10.1054 5.10536 10.2929 5.29289L12 7H19C20.1046 7 21 7.89543 21 9V10"
                        stroke="red"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M15.0251 14.0251C14.3918 14.6585 14 15.5335 14 16.5C14 18.433 15.567 20 17.5 20C18.4665 20 19.3415 19.6082 19.9749 18.9749M15.0251 14.0251C15.6585 13.3918 16.5335 13 17.5 13C19.433 13 21 14.567 21 16.5C21 17.4665 20.6082 18.3415 19.9749 18.9749M15.0251 14.0251L17.5 16.5L19.9749 18.9749"
                        stroke="red"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </div>
                  <span>{file.name}</span>
                </div>
              )}
            </div>
          </div>
        </div>
      ) : (
        <Notfound />
      )}
    </MainLayout>
  );
};

export default DetailsTicket;
